import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zM6 7h5v1.5H6V7zm13 12H5L19 5v14zm-4.5-3v2H16v-2h2v-1.5h-2v-2h-1.5v2h-2V16h2z"
}), 'ExposureSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ExposureSharp.js
// module id = 3486
// module chunks = 2